// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__34BUN","column":"style_column__33owv","row":"style_row__3u2I9"};